export const priority_levels = ['Critical', 'High', 'Medium', 'Low', 'Backlog'];
